import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { GlobalService } from "../../services/global.service";
import { SwiperService } from "../../services/swiper.service";

@Component({
    selector: "web-carousel",
    templateUrl: "./carousel.component.html",
    styleUrls: ["./carousel.component.scss"],
})
export class CarouselComponent implements AfterViewInit {
    @Input() isShowStore: boolean = true;
    @ViewChild("carouselSwiper") carouselSwiper!: ElementRef<HTMLElement>;

    constructor(
        public globalService: GlobalService,
        private swiperService: SwiperService
    ) {}

    ngAfterViewInit(): void {
        this.swiperService.initSwiper(this.carouselSwiper.nativeElement, {
            loop: true,
            autoplay: {
                delay: 2500,
            },
        });
    }
}
